import React, { useState } from 'react'
import Loadable from 'react-loadable'
import { RecoilRoot } from 'recoil'
import { Router, Location } from '@reach/router'
import { Provider } from 'unstated'
import '@reach/dialog/styles.css'

import Login from 'pages/login'
import NotFound from 'pages/notfound'
import ErrorBoundary from 'components/errorBoundary'

const Dashboard = Loadable({
	loader: () => import('pages/main'),
	loading: () => null
})

function Routes(props) {
	return (
		<Router {...props} style={{ height: '100%' }}>
			<Dashboard path="/*" />
			<Login path="/login" />
			<NotFound default />
		</Router>
	)
}

export default function Root() {
	const { isLoading } = useState(false)

	return (
		<RecoilRoot>
			<Provider>
				{isLoading ? null : (
					<ErrorBoundary
						fallback={() => null}
						onError={async (error) => {
							console.error(error)
						}}
					>
						<Location>
							{({ location }) => <Routes location={location} />}
						</Location>
					</ErrorBoundary>
				)}
			</Provider>
		</RecoilRoot>
	)
}
